export default "__VITE_ASSET__8aa253fd__"